'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caf = exports.raf = undefined;

var _exenv = require('exenv');

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['ms', 'moz', 'webkit'];

var tmpRaf = null;
var tmpCaf = null;

if (_exenv2.default.canUseDOM) {
  tmpRaf = window.requestAnimationFrame;
  tmpCaf = window.cancelAnimationFrame;

  // eslint-disable-next-line no-plusplus
  for (var x = 0; x < vendors.length && !tmpRaf; ++x) {
    tmpRaf = window[vendors[x] + 'RequestAnimationFrame'];
    tmpCaf = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }
} else {
  tmpRaf = function tmpRaf(callback) {
    return callback();
  };
  tmpCaf = function tmpCaf(id) {}; // eslint-disable-line no-unused-vars
}

var raf = exports.raf = tmpRaf;
var caf = exports.caf = tmpCaf;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(vendors, 'vendors', 'src/animations/request-animation-frame.js');

  __REACT_HOT_LOADER__.register(tmpRaf, 'tmpRaf', 'src/animations/request-animation-frame.js');

  __REACT_HOT_LOADER__.register(tmpCaf, 'tmpCaf', 'src/animations/request-animation-frame.js');

  __REACT_HOT_LOADER__.register(raf, 'raf', 'src/animations/request-animation-frame.js');

  __REACT_HOT_LOADER__.register(caf, 'caf', 'src/animations/request-animation-frame.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/react-stack-grid/lib/animations/request-animation-frame.js
// module id = 310
// module chunks = 35783957827783